import {
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { RoleProtectedRoute } from "./components/routeGuard/RoleProtectedRoute";
import PrivateRoute from "./components/routeGuard/PrivateRoute";
import ViewEntries from "./Pages/viewEntries";
import Entry from "./Pages/entry";
import Balance from "./Pages/balance";
import LoginPage from "./Pages/login";
import Homepage from "./Pages/HomePage";
import AddUserForm from "./adduser";
import RegisterPage from "./Pages/register";
import BottomBar from "./bottom-nav";
import PrivacyPolicy from "./Pages/privacyPolicy";
import Public_homepage from "./Pages/public_homepage";
import SideBar from "./components/SideBar";
import classNames from "classnames";
import UserDetail from "./Pages/UserDetail";
import AnimalPriceGrid from "./components/reusable/CowPriceEntryGrid";
import ArrivedCustomersPage from "./components/arrivedCustomer";
import { useLoginContext } from "./Contexts/LoginContext";
import ContactPage from "./Pages/ContactPage";
import { useEffect } from "react";
import CustomerTable from "./components/customerTable";
import PrivacyPolicyAata from "./Pages/PrivacyPolicyAata";
function Main() {
  const { role, loggedIn,checkedLogin } = useLoginContext();
  useEffect(() => {
    if (checkedLogin && !loggedIn && window.AndroidBridge && typeof window.AndroidBridge.logout === "function") {
      window.AndroidBridge.logout();
    }
  }, [loggedIn]);
  
  const location = useLocation();
  return (
    <>
      <div className="min-h-screen flex flex-col ">
        <div className="flex w-full bg-[#f1f5f7] ">

          {/* Main Content */}

          <main
            className={classNames(
              "flex w-full md:max-h-screen ", // always applied
            )}
          >
            <Routes location={location}>
              {/* Home page - all loggedIn except associated user restriction handled in component */}
              <Route
                path="/"
                element={
                  loggedIn ? (
                    <Homepage role={role} isLoggedIn={loggedIn} />
                  ) : (
                    <Public_homepage />
                  )
                }
              />

              {/* Admin only */}
              <Route
                path="/todays-customers"
                element={
                  <RoleProtectedRoute allowedRoles={["admin"]}>
                    <ArrivedCustomersPage />
                  </RoleProtectedRoute>
                }
              />
              <Route
                path="/customers"
                element={
                  <RoleProtectedRoute allowedRoles={["admin"]}>
                    <CustomerTable/>
                  </RoleProtectedRoute>
                }
              />
              <Route
                path="/addCustomer"
                element={
                  <RoleProtectedRoute allowedRoles={["admin"]}>
                    <AddUserForm />
                  </RoleProtectedRoute>
                }
              />
              <Route
                path="/addUser"
                element={
                  <RoleProtectedRoute allowedRoles={["admin"]}>
                    <AddUserForm />
                  </RoleProtectedRoute>
                }
              />
              <Route
                path="/user/:id"
                element={
                  <RoleProtectedRoute allowedRoles={["admin"]}>
                    <UserDetail />
                  </RoleProtectedRoute>
                }
              />

              {/* Logged in users (excluding associated user) */}
              <Route
                path="/entries/*"
                element={
                  <RoleProtectedRoute allowedRoles={["admin", "user"]}>
                    <Entry role={role} />
                  </RoleProtectedRoute>
                }
              />
              <Route
                path="/price/cow_Milk_Prices"
                element={
                  <RoleProtectedRoute allowedRoles={["admin", "user"]}>
                    <AnimalPriceGrid tableTitle="Cow" />
                  </RoleProtectedRoute>
                }
              />
              <Route
                path="/price/buffalo_Milk_Prices"
                element={
                  <RoleProtectedRoute allowedRoles={["admin", "user"]}>
                    <AnimalPriceGrid tableTitle="Buffalo" />
                  </RoleProtectedRoute>
                }
              />

              {/* Any logged-in user */}
              <Route
                path="view-entries/*"
                element={
                  <PrivateRoute>
                    <ViewEntries role={role} />
                  </PrivateRoute>
                }
              />
              <Route
                path="/balance/*"
                element={
                  <PrivateRoute>
                    <Balance role={role} />
                  </PrivateRoute>
                }
              />

              {/* Public routes */}
              <Route
                path="/login"
                element={<LoginPage  />}
              />
              <Route
                path="/register"
                element={<RegisterPage  />}
              />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/aataChakki/privacyPolicy" element={<PrivacyPolicyAata/>}/>
              <Route path="/Contact" element={<ContactPage/>} />
            </Routes>
          </main>
        </div>
      </div>

    </>
  );
}

export default Main;
